import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'record': {},
  'loading': false,
};

export const partNumberCodeInstance = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.GET_PNC_INSTANCE_INFO_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_PNC_INSTANCE_INFO_SUCCESS]: (state, action) => ({
      ...state,
      'record': action.response.data,
      'loading': false,
    }),
    [ActionTypes.GET_PNC_INSTANCE_INFO_FAILED]: (state, action) => ({
      ...state,
      'record': [{}],
      'loading': false,
    }),
    [ActionTypes.EDIT_PNC_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.EDIT_PNC_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.EDIT_PNC_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SAVE_PNC_RECORDS_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.SAVE_PNC_RECORDS_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SAVE_PNC_RECORDS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
